import { homepage as HOME_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import AuthWrapper from "./AuthWrapper";
import Loading from "../../components/feedback/Loading";
import LoginForm from "./auth-forms/LoginForm";
import { Grid, Stack, Typography } from "@mui/material";
import { setCredentials, reset as resetCredentials } from "../../store/global/authSlice";
import { useLoginMutation } from "../../api/authApi";
import { userApi } from "../../api/userApi";

function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [login, { isLoading: loginIsLoading }] = useLoginMutation();
    const [me, { isLoading: meIsLoading }] = userApi.endpoints.whoami.useLazyQuery();

    const handleSubmit = async (credentials) => {
        try {
            const tokenData = await login(credentials).unwrap();
            console.log("try get token:", tokenData);
            if (!tokenData?.user) {
                throw "Cannot login.";
            }
            const meData = await me().unwrap();
            console.log("try get me:", meData);
            if (!meData?.user) {
                throw "Invalid token";
            }
            dispatch(
                setCredentials({
                    user: meData?.user,
                    token: tokenData?.accessToken,
                })
            );
        } catch (error) {
            console.log("login error:", error.message);
            dispatch(resetCredentials());
        }
    };

    return (
        <AuthWrapper>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="baseline"
                        sx={{ mb: { xs: -0.5, sm: 0.5 } }}
                    >
                        <Typography variant="h3">LOGIN</Typography>
                        {/**
                        <Typography
                            component={Link}
                            to="/register"
                            variant="body1"
                            sx={{ textDecoration: "none" }}
                            color="primary"
                        >
                            Don&apos;t have an account?
                        </Typography>
                         */}
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    {loginIsLoading || meIsLoading ? <Loading /> : <LoginForm handleSubmit={handleSubmit} />}
                </Grid>
            </Grid>
        </AuthWrapper>
    );
}

export default Login;
